import { connect } from 'react-redux'
import PayrollCongratCard from './PayrollCongratCard'
import './style.css'

const mapStateToProps = ({ auth }) => ({ last_payrun: auth.last_payrun || {} })

export default connect(mapStateToProps)(PayrollCongratCard)
